/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2022-02-23 10:50:10
 * @LastEditors: hexy
 * @LastEditTime: 2023-12-21 09:56:46
 * @Description: 
 * @FilePath: \ICPSxin\src\api\smart\schedul\frontLog.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/FrontcourtForemanPage";
export const Download = "/icps/system/sign/basics/plan/exportListFrontcourtForeman";

/*获取开盘情况*/
export function opening(data) {
  return request({
    url: "/icps/system/sign/intelligent/opening/getDetailByPlanId",
    method: "post",
    data,
  });
}
/*获取收盘情况*/
export function closing(data) {
  return request({
    url: "/icps/system/sign/intelligent/closing/getDetailByPlanId",
    method: "post",
    data,
  });
}
/*获取施工日志*/
export function getListByPlanId(data) {
  return request({
    url: "/icps/system/sign/intelligent/roadworkLog/getListByPlanId",
    method: "post",
    data,
  });
}
/*获取施工详情*/
export function getDetailById(data) {
  return request({
    url: "/icps/system/sign/intelligent/roadworkLog/getDetailById",
    method: "post",
    data,
  });
}